export const ActionTypes = {
  FETCH_CONTACT_LABOURS:
    'services/dashboards/vision/contactTracingDashboard/fetch_contact_labours',
  SET_CONTACT_LABOURS:
    'services/dashboards/vision/contactTracingDashboard/set_contact_labours',
  SET_LOADER_STATUS:
    'services/dashboards/vision/contactTracingDashboard/set_loader_status',
};

const fetchContactLabours = () => ({
  type: ActionTypes.FETCH_CONTACT_LABOURS,
});

const setContactLabours = ({ contactLabours }) => ({
  contactLabours,
  type: ActionTypes.SET_CONTACT_LABOURS,
});
const setLoader = ({ showLoader }) => ({
  showLoader,
  type: ActionTypes.SET_LOADER_STATUS,
});

export default {
  fetchContactLabours,
  setContactLabours,
  setLoader,
};
